import AsyncStorage from '@react-native-async-storage/async-storage';

async function save(key, value) {
  try {
    if (value === undefined) value = null;
    if (value === undefined || !key) key = Date.now();
    await AsyncStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.log('###StorageService error', err);
  }
}

async function get(key) {
  try {
    let res = await AsyncStorage.getItem(key);
    if (res) res = JSON.parse(res);
    return res;
  } catch (err) {
    console.log('###StorageService error', err);
  }
  return null;
}

async function remove(key) {
  try {
    return AsyncStorage.removeItem(key);
  } catch (err) {
    console.log('ERROR', err);
  }
}

async function clear() {
  return AsyncStorage.clear();
}

export default {
  save,
  get,
  clear,
  remove
};
